/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Refund policy configuration
 * @export
 * @interface TournamentRefundPolicy
 */
export interface TournamentRefundPolicy {
    /**
     * Hours before start for 100% refund
     * @type {number}
     * @memberof TournamentRefundPolicy
     */
    fullRefundHours?: number;
    /**
     * Hours before start for 50% refund
     * @type {number}
     * @memberof TournamentRefundPolicy
     */
    partialRefundHours?: number;
    /**
     * Percentage refund in partial window
     * @type {number}
     * @memberof TournamentRefundPolicy
     */
    partialRefundPercent?: number;
    /**
     * Hours before start with 0% refund
     * @type {number}
     * @memberof TournamentRefundPolicy
     */
    noRefundHours?: number;
}

/**
 * Check if a given object implements the TournamentRefundPolicy interface.
 */
export function instanceOfTournamentRefundPolicy(value: object): value is TournamentRefundPolicy {
    return true;
}

export function TournamentRefundPolicyFromJSON(json: any): TournamentRefundPolicy {
    return TournamentRefundPolicyFromJSONTyped(json, false);
}

export function TournamentRefundPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRefundPolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'fullRefundHours': json['fullRefundHours'] == null ? undefined : json['fullRefundHours'],
        'partialRefundHours': json['partialRefundHours'] == null ? undefined : json['partialRefundHours'],
        'partialRefundPercent': json['partialRefundPercent'] == null ? undefined : json['partialRefundPercent'],
        'noRefundHours': json['noRefundHours'] == null ? undefined : json['noRefundHours'],
    };
}

export function TournamentRefundPolicyToJSON(json: any): TournamentRefundPolicy {
    return TournamentRefundPolicyToJSONTyped(json, false);
}

export function TournamentRefundPolicyToJSONTyped(value?: TournamentRefundPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fullRefundHours': value['fullRefundHours'],
        'partialRefundHours': value['partialRefundHours'],
        'partialRefundPercent': value['partialRefundPercent'],
        'noRefundHours': value['noRefundHours'],
    };
}

